module.exports = __webpack_public_path__ + "static/media/underline.d14fc3ea.svg";